<template>
<div>
  <div v-if="!route.middleware.length">
    <p class="has-text-danger">No Middleware Found.</p>
  </div>
  <div v-else>
    <p class="has-text-weight-bold  has-text-secondary">Middleware</p>
    <div v-for="middleware in route.middleware" :key="middleware.id">
      <p>
        <router-link class="is-flex justify-between" :to="{
          name: 'middleware-manager',
          params: {
            ...$route.params,
            middleware: middleware.id
          }}">
          <span>{{ middleware.name }}</span>
          <span class="has-text-danger" v-if="!middleware.type">Unclassified</span>
        </router-link>
      </p>
    </div>
  </div>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'
import { first } from 'lodash'

export default {

  computed: {
    ...mapGetters('route', [
      'route'
    ]),
  }

}
</script>